module.exports = __webpack_public_path__ + "static/media/rhino.2f0461c3.jpg";